import React, {Fragment, useState} from 'react';
import styled from 'styled-components';
import {ArrowDropUp, ArrowDropDown} from '@styled-icons/material';
import Image from '../Image';
import StatusBar from './StatusBar';
import {Row, Text, Label} from '../../Widgets';
import {Pagination} from 'antd';
const appConfig = require('../../data.json');

const Item = ({order, columns}) => {
  let [expand, setExpand] = useState(false);

  return (
    <Fragment>
      <div className="item">
        {columns.map((col, idx) => (
          <>
            <Row
              key={idx}
              {...(col.onClick ? {onClick: () => col.onClick(order)} : {})}>
              <Label flex="0 0 80px">{col.title}</Label>

              <div style={{flex: 1}}>
                {col.render ? (
                  col.render(order)
                ) : (
                  <Text size="sm">{order[col.dataIndex]}</Text>
                )}
              </div>

              {col.expandable && (
                <div
                  style={{paddingLeft: '20px'}}
                  onClick={() => setExpand(!expand)}>
                  {expand ? (
                    <ArrowDropUp color={'#aaa'} size={30} />
                  ) : (
                    <ArrowDropDown color={'#aaa'} size={30} />
                  )}
                </div>
              )}
            </Row>
          </>
        ))}
      </div>
      {expand && <StatusBar order={order} />}
    </Fragment>
  );
};

export default function SmallScreenTable({
  orders = [],
  loading,
  columns,
  filters,
  setFilters,
  total,
  noPage = false,
}) {
  if (loading) {
    return null;
  }

  return (
    <React.Fragment>
      <Wrapper>
        <div className="header row">訂單列表</div>

        {orders.length > 0 ? (
          orders.map((order, idx) => (
            <Item key={idx} order={order} columns={columns} />
          ))
        ) : (
          <div style={{textAlign: 'center', padding: 20}}>
            <Image src="/images/empty-order.svg" height="80" width="80" />
          </div>
        )}
      </Wrapper>
      {orders.length > 0 && !noPage && (
        <Pagination
          defaultCurrent={filters.current}
          pageSize={filters.pageSize}
          total={total}
          onChange={(pageNumber) => setFilters({current: pageNumber})}
        />
      )}
    </React.Fragment>
  );
}

const Wrapper = styled.div`
  border: solid 1px #ccc;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 10px;
  & > .header {
    background-color: #fafafa;
    border-bottom: solid 1px #ccc;
    font-weight: 600;
    padding: 15px;
  }

  & > .item {
    padding: 15px;
    border-bottom: solid 1px #ccc;
  }

  & .row {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  & > .expand {
    padding: 15px;
    background-color: #fafafa;
  }
`;
